import { findDeepGetActivityOfTask } from '../../../../views/lookahead/planification/index.helper';
import { isGrouped } from '../../GanttVisualization.helper';
import { formatDate, getClassOdd, setUpModificationRequest } from './utils';
import {
  createPendingContent,
  renderContentEndDate,
  renderIfNotTask
} from './templates';

const renderEnd = ({
  task,
  onlyRead,
  column,
  setModalModification,
  modalModification,
  t
}) => {
  const isOnlyReadElement = onlyRead || task?.readonly;

  /** No Render if parent is Abstract */
  const shouldRenderEmptySpan = () => isGrouped() && task?.type === null;
  if (shouldRenderEmptySpan()) return null;

  /** Check if data is defined. Activity don't have this data */
  const notTaskResult = renderIfNotTask(task, column);
  if (notTaskResult) return notTaskResult;

  /** get activity reference */
  const activityReference = findDeepGetActivityOfTask(
    window.activities,
    'id',
    task?.id
  );
  if (!activityReference) return '';

  /** this function intercepts the save call, and adds data */

  /**
   * This function handles the request acitivity modification
   * @param {*} task task which has problems of unfit dates
   * @param {*} activity activity to request modification
   */
  const handleActivityModificationRequest = (task, activity) => {
    setModalModification({
      ...modalModification,
      visible: true,
      title: t('modals.lookahead.activity_modification_request.title'),
      data: {
        task,
        activity
      }
    });
  };

  const classOdd = getClassOdd(task, column);
  const taskDate = task?.end_date;
  if (task.modificationSource === 'pending') {
    const dateStr = formatDate(task.end_date, window.ganttVisualization);
    return createPendingContent(dateStr, classOdd, task, t);
  }

  setUpModificationRequest({
    onlyRead,
    task,
    activityReference,
    handleActivityModificationRequest
  });

  return renderContentEndDate({ classOdd, taskDate, task, t });
};

export default renderEnd;
